import GlobalUtils from "@/utils/GlobalUtils";

import SntDefaultUserIcon from "@icons/SntDefaultUserIcon";

const ProfileDropdownTitle = ({ loginInfo }) => {
  return (
    <>
      {loginInfo.image ? (
        <img
          className="user-avatar"
          src={GlobalUtils.getFile(
            "user",
            loginInfo.userId,
            "avatar",
            loginInfo.image
          )}
          alt=""
          title={loginInfo.fullName}
        />
      ) : (
        <SntDefaultUserIcon
          size={24}
          role="button"
          title={loginInfo.fullName}
        />
      )}
    </>
  );
};

export default ProfileDropdownTitle;
